import api from './api';
import { ApiResponse, FechamentoAbastecimento, FechamentoRequest } from '../types';

export const fechamentoService = {
  listar: async (): Promise<FechamentoAbastecimento[]> => {
    const response = await api.get<FechamentoAbastecimento[]>('/fechamentos-abastecimento');
    return response.data;
  },

  buscarPorId: async (id: number): Promise<FechamentoAbastecimento> => {
    const response = await api.get<FechamentoAbastecimento>(`/fechamentos-abastecimento/${id}`);
    return response.data;
  },

  fechar: async (request: FechamentoRequest): Promise<ApiResponse<FechamentoAbastecimento>> => {
    const response = await api.post<ApiResponse<FechamentoAbastecimento>>('/fechamentos-abastecimento/fechar', request);
    return response.data;
  },

  gerarRelatorioPdf: async (id: number): Promise<Blob> => {
    const response = await api.get(`/fechamentos-abastecimento/${id}/relatorio-pdf`, {
      responseType: 'blob',
    });
    return response.data;
  },
};
